<div class="modal-header modal-block-primary">
  <button type="button" class="close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
    <span class="sr-only">Close</span>
  </button>
  <h4 class="modal-title">{{title}}</h4>
</div>
<div class="modal-body">
  <div class="modal-text">
    <p>{{message}}</p>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="confirm()">Ok</button>
</div>
